// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table__SelhrjViBh{table-layout:fixed;height:auto}.tableWrapper__J5FArppfcT{height:100%}.emoji__MIcD9eQwRu{font-size:var(--dixa-typography-size-400)}`, "",{"version":3,"sources":["webpack://./src/assets/components/teamPage/teamPage.module.scss"],"names":[],"mappings":"AAEA,mBACE,kBAAA,CACA,WAAA,CAGF,0BACE,WAAA,CAGF,mBACE,yCAAA","sourcesContent":["@import 'common';\n\n.table {\n  table-layout: fixed;\n  height: auto;\n}\n\n.tableWrapper {\n  height: 100%;\n}\n\n.emoji {\n  font-size: var(--dixa-typography-size-400);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `table__SelhrjViBh`,
	"tableWrapper": `tableWrapper__J5FArppfcT`,
	"emoji": `emoji__MIcD9eQwRu`
};
export default ___CSS_LOADER_EXPORT___;
